import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import DeliverSection from './components/DeliverSection';
import WhySection from './components/WhySection';
import IndustriesPreview from './components/IndustriesPreview';
import CtaSection from './components/CtaSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      <main>
        <HeroSection />
        <DeliverSection />
        <WhySection />
        <IndustriesPreview />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
